import { ContentWrapperStyled } from './ContentWrapper.styled.js'

export const ContentWrapper = ({ children }) => <ContentWrapperStyled>{children}</ContentWrapperStyled>
